import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-box-empty",
  "use": "check-box-empty-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check-box-empty\"><path fill-rule=\"evenodd\" d=\"M19.75 19.75H4.25V4.25h15.5v15.5ZM5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol